import { CardPosition, Market } from "types";
import { clamp, distance } from "popmotion";

// Prevent rapid reverse swapping
const buffer = 5;
export const findIndex = (
  i: number,
  yOffset: number,
  xOffset: number,
  positions: CardPosition[],
  numInRow: number
) => {
  let target = i;
  const { top, left, height, width } = positions[i];
  const bottom = top + height;
  const right = left + width;

  const yNextPosition = positions.length - 1 - i;

  // If moving down
  if (yOffset > 0) {
    const nextItem = positions[i + numInRow];
    if (nextItem) {
      const swapOffset =
        distance(bottom, nextItem.top + nextItem.height / 2) + buffer;
      if (yOffset > swapOffset) target = i + yNextPosition;
    }
    // If moving up
  } else if (yOffset < 0) {
    const prevItem = positions[i - numInRow];
    if (prevItem) {
      const prevBottom = prevItem.top + prevItem.height;
      const swapOffset =
        distance(top, prevBottom - prevItem.height / 2) + buffer;
      if (yOffset < -swapOffset) target = i - numInRow;
    }
  }

  // If moving right
  if (xOffset > 0) {
    let newPosition = i + 1;
    let nextItem = positions[newPosition];
    if (nextItem === undefined && i >= numInRow) {
      newPosition = i - ((i % numInRow) + 1);
      nextItem = positions[newPosition];
    }
    if (nextItem === undefined) return i;

    const swapOffset =
      distance(right, nextItem.left + nextItem.width / 2) + buffer;
    if (xOffset > swapOffset) target = newPosition;

    // If moving left
  } else if (xOffset < 0) {
    const prevItem = positions[i - 1];
    if (prevItem === undefined) return i;

    const prevRight = prevItem.left + prevItem.width;
    const swapOffset = distance(left, prevRight - prevItem.width / 2) + buffer;
    if (xOffset < -swapOffset) target = i - 1;
  }

  return clamp(0, positions.length, target);
};

export const createMoveCardRequest = (i: number, watchlist: Market[]) => {
  let prev: number | null = i - 1;
  let next: number | null = i + 1;

  if (i === 0) {
    prev = null;
  }
  if (i === watchlist.length - 1) {
    next = null;
  }

  const prevSymbol = prev !== null ? watchlist[prev].symbol : null;
  const prevExchange = prev !== null ? watchlist[prev].exchange : null;
  const nextSymbol = next !== null ? watchlist[next].symbol : null;
  const nextExchange = next !== null ? watchlist[next].exchange : null;

  return {
    symbol: watchlist[i].symbol,
    exchange: watchlist[i].exchange,
    prev_symbol: prevSymbol,
    prev_exchange: prevExchange,
    next_symbol: nextSymbol,
    next_exchange: nextExchange,
  };
};
